import { Github } from "lucide-react";
import { PROJECTS } from "@/data/projects";
import { InfoNote } from "@/components/InfoNote";
import { DEMOS } from "./demos";


export function ProjectWindow({ projectId }: { projectId?: string }) {
    const p = PROJECTS.find((x) => x.id === projectId);
    if (!p) return <p className="font-mono text-sm text-inkfaint">project not found. it may have wandered into a side quest.</p>;
    const Demo = DEMOS[p.demo];
    return (
        <div data-testid="project-window">
            <div className="flex flex-wrap items-center gap-2">
                <span className="font-mono text-[13px] font-bold text-ink">{p.name}</span>
                <span className="badge">{p.context}</span>
            </div>

            {[
                { title: "problem", body: <p className="text-[13px] leading-relaxed text-inksoft">{p.problem}</p> },
                { title: "approach", body: <p className="text-[13px] leading-relaxed text-inksoft">{p.approach}</p> },
                {
                    title: "technologies",
                    body: (
                        <div className="flex flex-wrap gap-1">
                            {p.tech.map((t) => (
                                <span key={t} className="chip">
                                    {t}
                                </span>
                            ))}
                        </div>
                    ),
                },
                { title: "my contribution", body: <p className="text-[13px] leading-relaxed text-inksoft">{p.contribution}</p> },
            ].map((s) => (
                <div key={s.title} className="mt-4">
                    <p className="font-mono text-[11px] font-bold uppercase tracking-wide text-elec">{s.title}</p>
                    <div className="mt-1">{s.body}</div>
                </div>
            ))}

            <div className="mt-4">
                <p className="font-mono text-[11px] font-bold uppercase tracking-wide text-elec">challenges</p>
                <div className="mt-1">
                    <InfoNote text={p.challenges} testId={`challenge-${p.id}`} />
                </div>
            </div>
            <div className="mt-3">
                <p className="font-mono text-[11px] font-bold uppercase tracking-wide text-elec">what i learned</p>
                <div className="mt-1">
                    <InfoNote text={p.learned} testId={`learned-${p.id}`} />
                </div>
            </div>

            <div className="mt-5 rounded-2xl border-2 border-ink p-4" style={{ background: p.tileBg }}>
                <p className="font-mono text-[11px] font-bold">interactive demo</p>
                <div className="mt-3">
                    <Demo />
                </div>
            </div>

            {p.repo ? (
                <a
                    data-testid={`project-repo-${p.id}`}
                    href={p.repo}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="mt-3 inline-flex items-center gap-1.5 font-mono text-[11px] font-bold text-elec underline decoration-dotted underline-offset-4 hover:decoration-solid"
                >
                    <Github size={13} /> {p.repo.replace("https://github.com/", "")}
                </a>
            ) : (
                <p className="mt-3 font-mono text-[10.5px] text-inkfaint">{p.repoNote}</p>
            )}
        </div>
    );
}
